import { render } from "./BackLayout.vue?vue&type=template&id=328da9fc&scoped=true"
import script from "./BackLayout.vue?vue&type=script&lang=js"
export * from "./BackLayout.vue?vue&type=script&lang=js"

import "./BackLayout.vue?vue&type=style&index=0&id=328da9fc&lang=scss&scoped=true"

import exportComponent from "C:\\xampp8\\htdocs\\AI4IRGClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328da9fc"]])

export default __exports__